import { render, staticRenderFns } from "./custom-form-tinymce.vue?vue&type=template&id=49a69840&scoped=true"
import script from "./custom-form-tinymce.vue?vue&type=script&lang=js"
export * from "./custom-form-tinymce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a69840",
  null
  
)

export default component.exports